<div class="page-content page-fill">
  @if (!!isClerk && !showAsDialog) {
    <div class="d-flex">
      <dx-file-uploader
        name="fileUpload"
        selectButtonText="Select File(s)"
        class="attachments hide-on-phone"
        accept="*"
        uploadMode="instantly"
        [showFileList]="false"
        [multiple]="true"
        [uploadUrl]="serviceName + '/api/utility/uploadCommitteeMinutes/'"
        (onUploadStarted)="uploadStarted($event)"
        (onUploadError)="uploadError($event)"
        (onUploaded)="uploaded($event)"
        [uploadHeaders]="uploadHeaders"
        >
      </dx-file-uploader>
    </div>
  }
  @if (documents) {
    <div class="grid-fill reconciliation-data-grid" [ngStyle]="{ 'min-height': showAsDialog ? '800px' : '100%' }">
      <dx-data-grid
        #dataGrid
        keyExpr="id"
        [dataSource]="documents"
        [showBorders]="true"
        [columnAutoWidth]="false"
        [focusedRowEnabled]="false"
        [showColumnLines]="true"
        [wordWrapEnabled]="true"
        (onToolbarPreparing)="onToolbarPreparing($event)"
        (onSelectionChanged)="onSelectionChanged($event)"
        (onCellDblClick)="rowDoubleClick($event)"
        (onRowPrepared)="rowPrepare($event)"
        >
        <!-- <dxi-column dataField="id" caption="Id" width="80"></dxi-column> -->
        <dxi-column dataField="created" caption="Date" dataType="date" width="100" [sortIndex]="1" [sortOrder]="'desc'"></dxi-column>
        <dxi-column dataField="committee.name" caption="Committee" width="160"></dxi-column>
        <dxi-column dataField="name" caption="Name" width="450"></dxi-column>
        <dxi-column dataField="viewed" format="shortDateShortTime" width="150"></dxi-column>
        <dxi-column dataField="dismissed" format="shortDate" width="100"></dxi-column>
        <!-- <dxi-column dataField="viewedCount" caption="# Read" width="75" [visible]="isMinutesReviewer"></dxi-column>
        <dxi-column dataField="unReadCount" caption="# Unread" width="75" [visible]="isMinutesReviewer"></dxi-column>
        <dxi-column dataField="readersHtml" caption="Read" width="575" [encodeHtml]="false" [allowSearch]="true" [visible]="isMinutesReviewer"></dxi-column>
        <dxi-column dataField="nonReadersHtml" caption="UnRead" width="575" [encodeHtml]="false" [allowSearch]="true" [visible]="isMinutesReviewer"></dxi-column> -->
        <dxi-column width="100"></dxi-column>
        <dxo-state-storing [enabled]="true" type="localStorage" storageKey="minutes-list-grid"></dxo-state-storing>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-search-panel class="hide-on-phone" [visible]="!mobile"></dxo-search-panel>
        <dxo-selection [mode]="'multiple'" [showCheckBoxesMode]="'onClick'"></dxo-selection>
        <div class="hide-on-phone" *dxTemplate="let data of 'toolbarButtons'">
          @if (!showAsDialog) {
            <button (click)="markAsViewed()" class="btn btn-sm btn-primary ms-4" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
              Mark As Viewed
            </button>
          }
          @if (!!isClerk && !showAsDialog) {
            <button
              (click)="markAsNonViewed()"
              class="btn btn-sm btn-primary ms-1"
              [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
              >
              Mark As UnRead
            </button>
          }
          @if (!showAsDialog) {
            <button (click)="dismiss()" class="btn btn-sm btn-primary ms-1" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
              Dismiss
            </button>
          }
          @if (!showAsDialog) {
            <button (click)="toggleShowAll()" class="btn btn-sm btn-warning ms-1">{{ showAll ? "Show Less" : "Show All" }}</button>
          }
          @if (!!isClerk && !showAsDialog) {
            <button (click)="emailNew()" class="btn btn-sm btn-primary ms-4" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
              Email
            </button>
          }
          @if (!!isClerk && !showAsDialog) {
            <button (click)="rename()" class="btn btn-sm btn-primary ms-4" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
              ReName
            </button>
          }
          @if (!!isClerk && !showAsDialog) {
            <button (click)="delete()" class="btn btn-sm btn-danger ms-4" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
              Delete
            </button>
          }
        </div>
        <div *dxTemplate="let data of 'toolbarText'">
          @if (documents) {
            <span class="me-3">
              <strong>{{ dataGrid.instance.totalCount() + " items" }}</strong>
            </span>
          }
          @if (documents) {
            <span class="me-3">
              <i>{{ "Double click lines to open" }}</i>
            </span>
          }
        </div>
      </dx-data-grid>
      <!-- <dx-data-grid
      #dataGrid
      keyExpr="id"
      [dataSource]="reviews"
      [showBorders]="true"
      [columnAutoWidth]="false"
      [focusedRowEnabled]="false"
      [showColumnLines]="true"
      [wordWrapEnabled]="true"
      (onToolbarPreparing)="onToolbarPreparing($event)"
      (onSelectionChanged)="onSelectionChanged($event)"
      (onCellDblClick)="rowDoubleClick($event)"
      (onRowPrepared)="rowPrepare($event)"
      >
      <dxi-column dataField="created" caption="Date" dataType="date" width="100" [sortIndex]="1" [sortOrder]="'desc'"></dxi-column>
      <dxi-column dataField="committeeAttachment.committee.name" caption="Committee" width="160"></dxi-column>
      <dxi-column dataField="committeeAttachment.name" caption="Name" width="450"></dxi-column>
      <dxi-column dataField="viewed" format="shortDateShortTime" width="150"></dxi-column>
      <dxi-column dataField="dismissed" format="shortDate" width="100"></dxi-column>
      <dxi-column dataField="viewedCount" caption="# Read" width="75" [visible]="isMinutesReviewer"></dxi-column>
      <dxi-column dataField="unReadCount" caption="# Unread" width="75" [visible]="isMinutesReviewer"></dxi-column>
      <dxi-column dataField="readersHtml" caption="Read" width="575" [encodeHtml]="false" [allowSearch]="true" [visible]="isMinutesReviewer"></dxi-column>
      <dxi-column dataField="nonReadersHtml" caption="UnRead" width="575" [encodeHtml]="false" [allowSearch]="true" [visible]="isMinutesReviewer"></dxi-column>
      <dxi-column width="100"></dxi-column>
      <dxo-state-storing [enabled]="true" type="localStorage" storageKey="minutes-list-grid"></dxo-state-storing>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-search-panel class="hide-on-phone" [visible]="!mobile"></dxo-search-panel>
      <dxo-selection [mode]="'multiple'" [showCheckBoxesMode]="'onClick'"></dxo-selection>
      <div class="hide-on-phone" *dxTemplate="let data of 'toolbarButtons'">
        <button *ngIf="!showAsDialog" (click)="markAsViewed()" class="btn btn-sm btn-primary ms-4" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
          Mark As Viewed
        </button>
        <button
          *ngIf="!!isClerk && !showAsDialog"
          (click)="markAsNonViewed()"
          class="btn btn-sm btn-primary ms-1"
          [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
          >
          Mark As UnRead
        </button>
        <button *ngIf="!showAsDialog" (click)="dismiss()" class="btn btn-sm btn-primary ms-1" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
          Dismiss
        </button>
        <button *ngIf="!showAsDialog" (click)="toggleShowAll()" class="btn btn-sm btn-warning ms-1">{{ showAll ? "Show Less" : "Show All" }}</button>
        <button *ngIf="!!isClerk && !showAsDialog" (click)="email()" class="btn btn-sm btn-primary ms-4" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
          Email
        </button>
        <button
          *ngIf="!!isClerk && !showAsDialog"
          (click)="email('document-package')"
          class="btn btn-sm btn-danger ms-2"
          [disabled]="dataGrid.instance.getSelectedRowsData().length === 0"
          >
          Email Document Package
        </button>
        <button *ngIf="!!isClerk && !showAsDialog" (click)="delete()" class="btn btn-sm btn-danger ms-4" [disabled]="dataGrid.instance.getSelectedRowsData().length === 0">
          Delete
        </button>
      </div>
      <div *dxTemplate="let data of 'toolbarText'">
        <span *ngIf="documents" class="me-3">
          <strong>{{ dataGrid.instance.totalCount() + " items" }}</strong>
        </span>
        <span *ngIf="documents" class="me-3">
          <i>{{ "Double click lines to open" }}</i>
        </span>
      </div>
    </dx-data-grid> -->
  </div>
}
</div>
